import { User } from './../../models/User';
import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';


/**
 * Generated class for the AdminUserComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'admin-user',
  templateUrl: 'admin-user.html'
})
export class AdminUserComponent {

  segment: string = "details";
  user: User;

  constructor(params: NavParams, public viewCtrl: ViewController) {
    this.user = params.get('user');
  }

  dismiss(){
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/components/admin-user/admin-user.ts